import { hideLoading, showLoading } from 'components/Loading/LoadingSlice';
import { ProductColumns } from 'pages/Admin/Component/Table/TableColumnsConfig';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import Utils from 'utils';
import useTableProperties from '../Component/Table/useTableProperties';
import propsProvider from './ProductPropsProvider';
import { deleteProductAdmin, getListProductAdmin, getProductAdminById, getQrCode, getUnit, insertProductAdmin, updateProductAdmin } from './ProductSlice';
import ProductMainView from './template/ProductMainView';
import moment from 'moment';
import Config from 'configuration';
import { deleteGinsengFile, getListGinsengAdmin } from '../Ginseng/GinsengSlice';

function ProductContainer(props) {
    const { dispatch, productAdminList } = props;

    const [keyword, setKeyword] = useState('');
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const intl = useIntl();
    const columns = ProductColumns(intl);
    const [openDialog, setOpenDialog] = useState(false);
    const [isAdd, setIsAdd] = useState(true);
    const [filesImage, setFilesImage] = useState([]);
    const [imageRemove, setImageRemove] = useState([]);
    const [ginseng, setGinseng] = useState('');
    const [productData, setProductData] = useState({});
    const [openDialogQR, setOpenDialogQR] = useState(false);
    const [selectOptions, setSelectOptions] = useState([]);
    const [updateData, setUpdateData] = useState(false);
    const [qrCodeBase64, setQrCodeBase64] = useState('');
    const [unit, setUnit] = useState([]);
    const payload = {
        currentPage: currentPage,
        pageSize: pageSize,
        sortField: 'created_at',
        sortOrder: 'desc',
        filters: '(name|code)@=' + keyword,
    };
    const tableData = useTableProperties(productAdminList);

    useEffect(() => {
        setCurrentPage(1);
    }, [pageSize, keyword]);

    useEffect(() => {
        dispatch(showLoading());
        const delayDebounceFn = setTimeout(async () => {
            const payloadGinseng = {
                currentPage: 1,
                pageSize: 10,
                sortField: 'created_at',
                sortOrder: 'desc',
            };
            const [productResult, ginsengResult] = await Promise.all([
                dispatch(getListProductAdmin(payload)),
                dispatch(getListGinsengAdmin(payloadGinseng)),
            ]);
            const selectOptions = [];
            const totalGinseng = Utils.getValues(ginsengResult, 'payload.responseData.count', 0);
            const ginsengRows = Utils.getValues(ginsengResult, 'payload.responseData.rows', []);
            const unit = await dispatch(getUnit());
            setUnit(Utils.getValues(unit, 'payload.responseData', []));
            if (totalGinseng > 10) {
                payloadGinseng.pageSize = totalGinseng;
                const newGinsengResult = await dispatch(getListGinsengAdmin(payloadGinseng));
                const newGinsengRows = Utils.getValues(newGinsengResult, 'payload.responseData.rows', []);
                newGinsengRows.forEach(item => {
                    selectOptions.push({ value: item.id, label: item.name });
                });
            }
            else {
                ginsengRows.forEach(item => {
                    selectOptions.push({ value: item.id, label: item.name });
                });
            }
            setSelectOptions(selectOptions);
            dispatch(hideLoading());
        }, 1000);
        return () => clearTimeout(delayDebounceFn);
    }, [pageSize, keyword, currentPage, dispatch, updateData]);

    const handleAddClick = () => {
        setStateHandle(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };
    const handleCloseDialogQR = () => {
        setOpenDialogQR(false);
    };
    const setStateHandle = (isAdd = false) => {
        setIsAdd(isAdd);
        setOpenDialog(true);
        setFilesImage([]);
        setImageRemove([]);
    };
    const handleSubmit = async (data) => {
        if (handleValidation(data)) return;
        dispatch(showLoading());
        const product = {
            name: data.name,
            code: data.qr_code,
            unit_id: data.checkbox ? unit[1].id : unit[0].id,
            unit_value: data.unit_value,
            manufacture_date: data.manufactureDate,
            description: data.description,
            other_information: data.other_information,
            ginseng_id: ginseng === "" ? data.ginseng_id : ginseng,
        }
        const uploadPromises = [];
        let newImageList = [];
        let status = Config.FAIL;
        if (isAdd) {
            for (const file of filesImage) {
                uploadPromises.push(Utils.processFile(dispatch, file));
            } try {
                const imageList = await Promise.all(uploadPromises);
                product['images'] = imageList;
                const result = await dispatch(insertProductAdmin(product));
                status = Utils.getValues(result, 'payload.status', Config.FAIL);
                const checkDuplicate = Utils.getValues(result, 'payload.message', '');

                if (checkDuplicate.includes(Config.Duplicate)) {
                    const deletePromises = imageList.map((value) =>
                        dispatch(deleteGinsengFile(value.id)),
                    );
                    await Promise.all(deletePromises);
                    dispatch(hideLoading());
                    return Utils.handlePopup(intl.messages.duplicateCode, 'warning');
                }
            } catch (error) { }
        }
        else {
            const newFiles = filesImage.filter((item) => item instanceof File);
            const oldFiles = filesImage.filter(
                (item) => item instanceof Object && !(item instanceof File),
            );
            if (imageRemove.length > 0) {
                const deletePromises = imageRemove.map((value) =>
                    dispatch(deleteGinsengFile(value.id)),
                );
                await Promise.all(deletePromises);
            }
            for (const file of newFiles) {
                uploadPromises.push(Utils.processFile(dispatch, file));
            }
            try {
                newImageList = await Promise.all(uploadPromises);
                product['images'] = [...oldFiles, ...newImageList];
                const updateProduct = {
                    id: data.id,
                    product: product,
                };
                const result = await dispatch(updateProductAdmin(updateProduct));
                status = Utils.getValues(result, 'payload.status', Config.FAIL);
            } catch (error) {
                Utils.handlePopup(
                    isAdd ? intl.messages.addFail : intl.messages.updateFail,
                    'error',
                );
            }
        }
        if (status === Config.SUCCESS) {
            setUpdateData(!updateData);
            Utils.handlePopup(
                isAdd ? intl.messages.addSuccess : intl.messages.updateSuccess,
                'success',
            );
        } else {
            if (isAdd) {
                const deletePromises = filesImage.map((value) =>
                    dispatch(deleteGinsengFile(value.id)),
                );
                await Promise.all(deletePromises);
            }
            else {
                const deletePromises = newImageList.map((value) =>
                    dispatch(deleteGinsengFile(value.id)),
                );
                await Promise.all(deletePromises);
            }
            Utils.handlePopup(isAdd ? intl.messages.addFail : intl.messages.updateFail, 'error');
        }
        dispatch(hideLoading());
        setOpenDialog(false);
    };

    const handleEditClick = async (e) => {
        dispatch(showLoading());
        const result = await dispatch(getProductAdminById(e.id));
        if (Utils.getValues(result, 'payload.status', Config.FAIL) === Config.SUCCESS) {
            const response = Utils.getValues(result, 'payload.responseData', {});
            setProductData(response);
            setStateHandle(false);
        }
        e.images.forEach((value) => {
            setFilesImage((prev) => [...prev, value]);
        });
        dispatch(hideLoading());
    };

    const handleDeleteClick = async (e) => {
        const result = await Utils.handleConfirmDelete(intl);
        if (result.isConfirmed) {
            dispatch(showLoading());
            await dispatch(deleteProductAdmin(e.data.id)).then((result) => {
                const status = Utils.getValues(result, 'payload.status', null);
                if (status === Config.SUCCESS) {
                    setUpdateData(!updateData);
                    Utils.handlePopup(intl.messages.deleteSuccess, 'success');
                } else {
                    Utils.handlePopup(intl.messages.deleteFail, 'error');
                }
            });
            setUpdateData(!updateData);
            dispatch(hideLoading());
        }
    };

    const handleValidation = (data) => {
        if (!data.qr_code) {
            Utils.handlePopup(intl.messages.requiredCode, 'error');
            return true;
        }
        if (!data.name) {
            Utils.handlePopup(intl.messages.requiredName, 'error');
            return true;
        }
        if (!data.unit_value) {
            Utils.handlePopup(intl.messages.requiredUnitValue, 'error');
            return true;
        }
        if (!data.manufactureDate) {
            Utils.handlePopup(intl.messages.requiredManufactureDate, 'error');
            return true;
        }
        if (!data.description) {
            Utils.handlePopup(intl.messages.requiredDescription, 'error');
            return true;
        }
        if (filesImage.length < 1) {
            Utils.handlePopup(intl.messages.requiredImage, 'error');
            return true;
        }
        return false;
    };



    const initialValues = {
        name: '',
        qr_code: '',
        created_at: Utils.formatDateYDM(moment()),
        manufactureDate: '',
        unit_value: '',
        description: '',
        other_information: '',
        ginseng_id: '',
        checkbox: false,
        qr: '',
    }

    const selectStyle = {
        control: base => ({
            ...base,
            border: '0 !important',
            boxShadow: '0 !important',
            height: '30px',
            minHeight: '30px',
            '&:hover': {
                border: '0 !important'
            }
        }),
        valueContainer: base => ({
            ...base,
            padding: '0',
        }),
        input: base => ({
            ...base,
            margin: '0',
        })
    }

    const handleOnchangeImage = (e) => {
        if (e.target.files[0]) {
            setFilesImage((prev) => [...prev, e.target.files[0]]);
        }
    };
    const handleRemoveImage = (e) => {
        setImageRemove((prev) => [...prev, e]);
        const newFiles = filesImage.filter((item) => item !== e);
        setFilesImage(newFiles);
    };
    const handleImage = (item) => {
        if (item instanceof File) {
            return URL.createObjectURL(item);
        } else {
            return Config.domain + item.file_path.substring(1);
        }
    };

    const handleSelectGinseng = (data) => {
        setGinseng(data.value);
    }

    const showQrImage = async (qr, code) => {
        let base64 = qr;
        if (isAdd) {
            if (!code) {
                return Utils.handlePopup(intl.messages.enterCodeGetQR, 'error');
            }
            dispatch(showLoading());
            const result = await dispatch(getQrCode(code));
            base64 = Utils.getValues(result, 'payload.responseData', '');
        }
        setQrCodeBase64(base64);
        dispatch(hideLoading());
        setOpenDialogQR(true);
    }

    const productContainerProps = {
        ...props,
        intl,
        keyword,
        setKeyword,
        handleEditClick,
        handleDeleteClick,
        openDialog,
        handleAddClick,
        handleCloseDialog,
        isAdd,
        tableData,
        pageSize,
        setPageSize,
        currentPage,
        setCurrentPage,
        handleSubmit,
        initialValues,
        columns,
        filesImage,
        handleRemoveImage,
        handleImage,
        handleOnchangeImage,
        selectStyle,
        selectOptions,
        handleSelectGinseng,
        productData,
        showQrImage,
        openDialogQR,
        handleCloseDialogQR,
        qrCodeBase64,
        unit,
    };
    return <ProductMainView {...propsProvider(productContainerProps)} />;
}

export default ProductContainer;
